import { useParams } from 'react-router-dom';
import { SubBar } from '@/design/components';
import { Conversation } from './Conversation';
import { useChannel } from './api';

/** ערוץ אחד באפליקציה של העובד. השיחה עצמה היא Conversation. */
export function ChannelPage() {
  const { channelId = '' } = useParams();
  const channel = useChannel(channelId);

  return (
    <div className="grid min-h-[calc(100dvh-8.5rem)] grid-rows-[auto_1fr]">
      <SubBar
        title={channel.data?.name ?? 'ערוץ'}
        subtitle={channel.data?.description ?? undefined}
      />
      <Conversation channelId={channelId} />
    </div>
  );
}
